import fonts from './fonts';
import responsive from './responsive';
// import spacing from './spacing';

export const mainColor = '#000';
export const secondaryColor = '#b2b2b2';

export const divisorColor = '#f2f2f2';

export const enum directions {
    top = 1,
    bottom = 1 << 1,
    left = 1 << 2,
    right = 1 << 3,
    all = 1 | 1 << 1 | 1 << 2 | 1 << 3,
    sides = 1 << 2 | 1 << 3
};

// const prefixed = (prefix: string, value: number, multi: number = 1, dir: directions = directions.sides) => ({
//     [prefix ? `${prefix}Left` : 'left']:
//         (dir & directions.left) === directions.left && value * multi || undefined,
//     [prefix ? `${prefix}Right` : 'right']:
//         (dir & directions.right) === directions.right && value * multi || undefined,
//     [prefix ? `${prefix}Bottom` : 'bottom']:
//         (dir & directions.bottom) === directions.bottom && value * multi || undefined,
//     [prefix ? `${prefix}Top` : 'top']:
//         (dir & directions.top) === directions.top && value * multi || undefined
// });

export const bodyFontSize = {
    'Mobile': 14,
    'Tablet': 16,
    'Laptop': 16,
    'Desktop': 16,
    'BigDesktop': 16
}

export default {
    'Body': {
        ...fonts.NeueHaasGroteskNormal,
        color: mainColor,
        lineHeight: '1.4',
        [responsive.Mobile]: {
            fontSize: bodyFontSize.Mobile,
        },
        [responsive.Tablet]: {
            fontSize: bodyFontSize.Tablet,
        },
        [responsive.Laptop]: {
            fontSize: bodyFontSize.Laptop,
        },
        [responsive.Desktop]: {
            fontSize: bodyFontSize.Desktop,
        },
        [responsive.BigDesktop]: {
            fontSize: bodyFontSize.BigDesktop,
        }
    },
    'BoldText': {
        ...fonts.NeueHaasGroteskBold,
    },
    'RegularText': {
        ...fonts.NeueHaasGroteskNormal,
    },
    'MainTitle': {
        ...fonts.NeueHaasGroteskBold,
        lineHeight: '1',
        [responsive.Mobile]: {
            fontSize: `2rem`,
        },
        [responsive.Tablet]: {
            fontSize: `2.5rem`,
        },
        [responsive.Laptop]: {
            fontSize:`2.5rem`,
        },
        [responsive.Desktop]: {
            fontSize: `2.5rem`,
        },
        [responsive.BigDesktop]: {
            fontSize: `2.5rem`,
        }
    },
    'SubTitle': {
        ...fonts.NeueHaasGroteskBold,
        [responsive.Mobile]: {
            fontSize: `1.3rem`,
        },
        [responsive.Tablet]: {
            fontSize: `1.3rem`,
        },
        [responsive.Laptop]: {
            fontSize: `1.3rem`,
        },
        [responsive.Desktop]: {
            fontSize: `1.3rem`,
        },
        [responsive.BigDesktop]: {
            fontSize: `1.3rem`,
        }
    },
    'Introduction': {
        ...fonts.NeueHaasGroteskNormal,
        [responsive.Mobile]: {
            fontSize: `${18/bodyFontSize.Mobile}rem`,
        },
        [responsive.Tablet]: {
            fontSize: `${20/bodyFontSize.Tablet}rem`,
        },
        [responsive.Laptop]: {
            fontSize: `${20/bodyFontSize.Laptop}rem`,
        },
        [responsive.Desktop]: {
            fontSize: `${20/bodyFontSize.Desktop}rem`,
        },
        [responsive.BigDesktop]: {
            fontSize: `${24/bodyFontSize.BigDesktop}rem`,
        }
    },
    'Caption': {
        ...fonts.NeueHaasGroteskNormal,
        fontSize: '.75rem',
        // [responsive.Mobile]: {
        //     fontSize: `${12/bodyFontSize.Mobile}rem`,
        // },
        // [responsive.Tablet]: {
        //     fontSize: `${14/bodyFontSize.Tablet}rem`,
        // },
        // [responsive.Laptop]: {
        //     fontSize: `${14/bodyFontSize.Laptop}rem`,
        // },
        // [responsive.Desktop]: {
        //     fontSize: `${14/bodyFontSize.Desktop}rem`,
        // },
        // [responsive.BigDesktop]: {
        //     fontSize: `${16/bodyFontSize.BigDesktop}rem`,
        // }
    },
    'Show': {
        opacity: 1,
        transform: 'translateY(0px)',
    },
    'Hide': {
        opacity: 0,
        transform: 'translateY(20px)',
        transition: '.2s all linear',
    },
    'ObjectFitCover': {
        fontFamily: '"object-fit: cover;"'
    },
    'ObjectFitContain': {
        fontFamily: '"object-fit: contain;"'
    }
    // 'PaddingGutter': (multi: number = 1, dir: directions = directions.sides) => ({
    //     [responsive.Mobile]: prefixed('padding', spacing.Gutter.Mobile, multi, dir),
    //     [responsive.Tablet]: prefixed('padding', spacing.Gutter.Tablet, multi, dir),
    //     [responsive.Laptop]: prefixed('padding', spacing.Gutter.Laptop, multi, dir),
    //     [responsive.Desktop]: prefixed('padding', spacing.Gutter.Desktop, multi, dir),

    // }),
    // 'MarginGutter': (multi: number = 1, dir: directions = directions.sides) => ({
    //     [responsive.Mobile]: prefixed('margin', spacing.Gutter.Mobile, multi, dir),
    //     [responsive.Tablet]: prefixed('margin', spacing.Gutter.Tablet, multi, dir),
    //     [responsive.Laptop]: prefixed('margin', spacing.Gutter.Laptop, multi, dir),
    //     [responsive.Desktop]: prefixed('margin', spacing.Gutter.Desktop, multi, dir)
    // }),
    // 'PostionGutter': (multi: number = 1, dir: directions = directions.sides) => ({
    //     [responsive.Mobile]: prefixed('', spacing.Gutter.Mobile, multi, dir),
    //     [responsive.Tablet]: prefixed('', spacing.Gutter.Tablet, multi, dir),
    //     [responsive.Laptop]: prefixed('', spacing.Gutter.Laptop, multi, dir),
    //     [responsive.Desktop]: prefixed('', spacing.Gutter.Desktop, multi, dir)
    // })
};


// WEBPACK FOOTER //
// ./src/constants/stylesheet.ts